require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-post-your-rss-feed-items-facebook-and-twitter.json") })
        }
      }, "path---post-post-your-rss-feed-items-facebook-and-twitter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-post-your-rss-feed-items-facebook-and-twitter!./.cache/json/post-post-your-rss-feed-items-facebook-and-twitter.json
// module id = 348
// module chunks = 231608221292675